import Moment from 'moment';
import { formatDollars } from './utilities';

class TranformSubmissionError extends Error {
    constructor(msg, args) {
        super(msg);
        this.name = 'RatingError';
        const { data } = args;
        this.data = data;
    }
}

/**
 * Transforms submission object to the one with more meaningful data (for client)
 *
 * @param {Object} submission (raw data)
 * @throws {Object} TypeError
 * @returns {Object}
 */
exports.transformSubmission = submission => {
    if (submission === null) {
        throw new TypeError();
    }

    const rating = submission.ratings || submission.rating;

    if (!rating) {
        return;
    }

    const premiumType = rating[submission.type];

    if (!premiumType) {
        throw new TranformSubmissionError('Rating without specified type', {
            data: { submissionId: submission.id }
        });
    }

    const basePremium = premiumType.basePremium || premiumType.premium;

    let quoteStatus;
    if (premiumType && basePremium && submission.clearanceStatus === 'pass') {
        quoteStatus = 'Priced';
    } else if (!premiumType || (!basePremium && submission.clearanceStatus === 'pass')) {
        quoteStatus = 'Referred';
    } else if (submission.clearanceStatus === 'pending') {
        quoteStatus = 'Pending Clearance';
    } else if (submission.clearanceStatus === 'fail') {
        quoteStatus = 'Failed Clearance';
    }

    return {
        id: submission.id,
        clearanceStatus: submission.clearanceStatus,
        primaryInsuredName: submission.primaryInsuredName,
        totalCost: submission.totalCost ? formatDollars(submission.totalCost) : 'n/a',
        quotedPremium:
            premiumType && basePremium && submission.clearanceStatus === 'pass'
                ? formatDollars(basePremium)
                : 'n/a',
        totalPremium:
            premiumType && premiumType.totalPremium && submission.clearanceStatus === 'pass'
                ? formatDollars(premiumType.totalPremium)
                : 'n/a',
        type: submission.type,
        updatedAt: submission.updatedAt,
        dateCreated: submission.createdAt
            ? Moment(submission.createdAt).format('MM-DD-YY hh:mma')
            : null,
        dateUpdated: submission.updatedAt
            ? Moment(submission.updatedAt).format('MM-DD-YY hh:mma')
            : null,
        ableToEdit:
            submission.clearanceStatus && submission.clearanceStatus !== 'fail' ? 'Yes' : 'No',
        quoteStatus
    };
};

/**
 * Transforms submission array to one with more meaningful data (for client)
 *
 * @param {Array} submissionsArray
 * @throws {} TypeError
 * @return {Array} Augmented list of submissions
 */
exports.transformSubmissionData = submissionsArray => {
    if (!Array.isArray(submissionsArray)) {
        throw new TypeError();
    }
    const list = submissionsArray.map(item => {
        try {
            return exports.transformSubmission(item);
        } catch (err) {
            if (err.name === 'RatingError') {
                return console.error(err.message, err.data);
            }
            return console.error(err);
        }
    });

    return list.filter(item => item);
};
